exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "footer.footer .credits[data-v-2cb2ab52]{-webkit-column-gap:15px;-moz-column-gap:15px;column-gap:15px}", ""]);

// exports
